import { LayoutHOC } from "base/ui/layout/layout";
import { createStyleCategory } from ".";

export const createStyleCategoryPage = (layoutHOC: LayoutHOC) => {
  return layoutHOC(createStyleCategory());
};
